<template>
    <span
        ><a
            href="#"
            @click="onClick"
            >{{ (props.row?.Caption ?? '') != '' ? props.row?.Caption : (props.row?.FileName ?? props.value ?? '') }}</a
        ></span
    >
</template>
<script setup lang="ts">
import { useHelper } from '@/composeables';
import { FileArchiveDao } from '@/dao';
import { $ti } from '@/locize';
import type { FileArchiveItem } from '@/objects/generated';
import { useToastStore } from '@/stores';
import { downloadFileFromStream } from '@/utilities/utils';

const props = defineProps<{
    /**
     * The file name to display
     */
    value: string | null;

    /**
     *
     */
    row?: FileArchiveItem | null;
}>();

const onClick = async (event: MouseEvent) => {
    const filename = props.row?.FileName;

    if (filename == null || filename.length === 0) {
        return;
    }

    // if it is a pdf we want to open the file, or else we want to download it
    const { stream } = await FileArchiveDao.DownloadFile(props.row?.FileGuid!);

    if (stream == null) {
        useToastStore().addError($ti('filearchive.downloadfailed', { filename: filename }, true));
        return;
    }
    downloadFileFromStream(stream!, filename);

    useToastStore().addSuccess($ti('filearchive.downloadsucceeded', { filename: filename }, true));

    return useHelper().stopPropagation(event);
};
</script>
